<!-- Rank all loader -->
<!--<terra-loader *ngIf="isLoading$ | async" class="loader"></terra-loader>-->

<!-- List of investments -->
<mat-accordion *ngIf="fundraising$ | async as fundraising" #accordion="matAccordion" class="investors-list">

  <!-- Sorting / Filtering -->
  <div class="filter-and-sorting">
    <div class="wrapper">
      <!-- Name filter -->
      <div class="filter-wrapper">
        <terra-search-field
          [placeholder]="'Search within ' + ((investments$ | async)?.length || 0) + ' Investors'"
          [(filter)]="nameFilterValue"
          (filterChange)="onNameFilterChange($event)"
          (clearSearch)="onClearNameFilter()"
        />
        
      </div>
       <mat-form-field appearance="outline" class="status-filter" >
          <mat-select [formControl]="selectedStatus" multiple>
              <mat-select-trigger>
                {{getStatusLabel()}}
              </mat-select-trigger>
              @for (status of availableStatuses; track status.key) {
                <mat-option [value]="status">{{status.title}}</mat-option>
              }
          </mat-select>
        </mat-form-field>
        <terra-loader *ngIf="isLoading$ | async" class="loader" />
    </div>

    <!-- Add investor -->
    <span>
      <button mat-button [matMenuTriggerFor]="addInvestorMenu" class="add-investor-button">
        <mat-icon class="notranslate">add</mat-icon>
        Add Investor
      </button>
      <mat-menu #addInvestorMenu="matMenu">
        <button mat-menu-item (click)="addFromContactList()">
          <mat-icon class="notranslate">add</mat-icon>
          Add From Contact List
        </button>
        <button mat-menu-item (click)="createNewContact()">
          <mat-icon class="notranslate">add</mat-icon>
          Create New Contact
        </button>
        <mat-divider />
        <button mat-menu-item class="participating-fund" (click)="openParticipatingFundDialog()" [disabled]="!(isFundFeatureActive$ | async)">
          <span class="premium-box">PREMIUM</span>
          <mat-icon class="notranslate">add</mat-icon>
          Add Participating Fund
        </button>
      </mat-menu>
    </span>

  </div>

  <!-- Table Header -->
  <div class="table-header" *ngIf="(orderedInvestments$ | async)?.length > 0">
    <div class="header-column investor-column sortable" 
         *ngIf="allowInvestorName$ | async"
         (click)="toggleSort('name')"
         [class.active]="isColumnSorted('name')">
      Investor
      <mat-icon class="sort-icon" *ngIf="isColumnSorted('name')">
        {{ getSortDirection('name') === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
      </mat-icon>
    </div>
    <div class="header-column investor-column" *ngIf="!(allowInvestorName$ | async)">Investor</div>
    <div class="header-column accreditation-column sortable">
      <div *terraSystemFeatureFlag="FeatureFlagConsts.SystemFeatureFlagAccreditationOn"
          (click)="toggleSort('accreditation')"
          [class.active]="isColumnSorted('accreditation')">
        Accreditation
        <mat-icon class="sort-icon" *ngIf="isColumnSorted('accreditation')">
          {{ getSortDirection('accreditation') === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
        </mat-icon>
      </div>
    </div>
    <div class="header-column call-date-column sortable" 
         (click)="toggleSort('callDate')"
         [class.active]="isColumnSorted('callDate')">
      Call Date
      <mat-icon class="sort-icon" *ngIf="isColumnSorted('callDate')">
        {{ getSortDirection('callDate') === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
      </mat-icon>
    </div>
    <div class="header-column amount-column sortable" 
         (click)="toggleSort('amount')"
         [class.active]="isColumnSorted('amount')">
      Amount
      <mat-icon class="sort-icon" *ngIf="isColumnSorted('amount')">
        {{ getSortDirection('amount') === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
      </mat-icon>
    </div>
    <div class="header-column status-column sortable" 
         (click)="toggleSort('status')"
         [class.active]="isColumnSorted('status')">
      Status
      <mat-icon class="sort-icon" *ngIf="isColumnSorted('status')">
        {{ getSortDirection('status') === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
      </mat-icon>
    </div>
  </div>

  <!-- investments -->
  <ng-container *ngIf="orderedInvestments$ | async as orderedInvestments">
    <terra-loader *ngIf="isDeletingInvestment; else investmentsData"></terra-loader>
    <ng-template #investmentsData>
      <mat-expansion-panel *ngFor="let investment of orderedInvestments | investmentStatusFilter:selectedStatus?.value; trackBy: investmentTrackByFn"
                           class="expansion-panel"
                           [expanded]="fundraising.investments.length === 1 || investment.id === scrollToInvestmentId"
                           (afterExpand)="scrollToInvestmentPanel(investment.id)"
                           (closed)="closePanel(investment.id)"
                           (opened)="openPanel(investment.id)"
                           [attr.id]="'investment_' + investment.id">
        <mat-expansion-panel-header class="panel-header" collapsedHeight="64px" expandedHeight="113px">
          <mat-panel-title class="panel-title">
            <div class="name-section">
              <div class="lo_sensitive investor-name">{{ getFormattedInvestorName(investment) | async }}</div>
              <span class="ie-name">{{ investment.investingEntity.id }}</span>
            </div>

            <div class="accreditation-cell" *terraSystemFeatureFlag="FeatureFlagConsts.SystemFeatureFlagAccreditationOn">
              {{ getShortAccreditationStatus(investment.investingEntity.accreditation?.status) }}
            </div>

            <div class="call-date-cell">
              {{ investment.paymentRequestSendDate ? (investment.paymentRequestSendDate | date:'dd MMMM yyyy') : (investment.paymentSettlementDate ? (investment.paymentSettlementDate | date:'dd MMMM yyyy') : '-') }}
            </div>

            <div class="amount-cell" [class.missing-amount]="investment.finalAmount === 0 && (isCompletedExternalContribution$ | async)">
              {{ investment.currency.symbol }}{{ (investment.finalAmount ? investment.finalAmount : investment.estimatedAmount) | number }}
            </div>

            <div class="status-cell">
              <span class="status-badge" [ngClass]="getStatus(investment)?.class">
                {{ getStatus(investment)?.title }}
              </span>
            </div>
          </mat-panel-title>
          <div class="remove-button-wrapper"
               *ngIf="allowToDeleteInvestment(investment)">
            <button [ngClass]="{'hidden':fundraising.investments.length === 1}" class="remove-button"
                    mat-icon-button (click)="deleteInvestment(investment.id, $event)"
                    matTooltip="Delete investment">
              <mat-icon class="notranslate">remove_circle_outline</mat-icon>
            </button>
          </div>
        </mat-expansion-panel-header>
        <!-- Content -->
        <ng-template matExpansionPanelContent>
          <span *ngIf="investment.rank !== InvestorRank.None"
                class="color-column"
                [ngClass]="{'high-rank-color': investment.rank === InvestorRank.Higher,
                             'normal-rank-color': investment.rank === InvestorRank.Normal,
                             'low-rank-color': investment.rank === InvestorRank.Lower}">
          </span>
          <terra-asset-investor *ngIf="gpHoldingService.holdingDiscriminator === HoldingDiscriminator.Asset"
            [investmentId]="investment.id" [investmentDetails]="investment" [hasCommitments]="hasCommitments$ | async" [refreshCommitmentsTrigger$]="refreshTotalCommitments$"
            [ngClass]="'flow-investment-panel-status-' + investment.status"></terra-asset-investor>
          <terra-fund-investor *ngIf="gpHoldingService.holdingDiscriminator === HoldingDiscriminator.Fund"
            [investmentId]="investment.id" [investmentDetails]="investment" [hasCommitments]="hasCommitments$ | async" [refreshCommitmentsTrigger$]="refreshTotalCommitments$"
            [ngClass]="'flow-investment-panel-status-' + investment.status"></terra-fund-investor>
        </ng-template>
      </mat-expansion-panel>
    </ng-template>

    <div *ngIf="orderedInvestments.length === 0" class="terra-card empty-state">
      <img class="image" src="assets/images/general/people.png"/>
      <h2 class="all-filtered-message">
        {{nameFilter.value ? 'Investors with the name you entered were not found' : 'Lets add your first investor'}}
      </h2>

      <ng-container *ngIf="!nameFilter.value">
        <button mat-button class="button add-existing" (click)="addFromContactList()">
          <mat-icon class="notranslate">add</mat-icon>
          Add From Contact List
        </button>
        <button mat-button class="button create-new" (click)="createNewContact()">
          <mat-icon class="notranslate">add</mat-icon>
          Create New Contact
        </button>
      </ng-container>
    </div>
  </ng-container>
</mat-accordion>
